<template>
    <section>
      <div style="padding-top: 22px" v-if="addOns.appMenu" >
        <div class="hero is-bold">
          <div class="hero-body" style="padding-left: 0px; padding-top: 0px">
            <div >
              <h1 class="title" style="color:#3e8ed0">PDFs</h1>
              <h5 class="subtitle">Manage your app menu PDFs here.</h5>
            </div>
          </div>
        </div>
        <div v-for="(pdfList, groupId) in groupedTableData" :key="groupId" class="mb-5">
          <h3 class="title is-5">App Menu PDF item: {{ getAppMenuPdfItem(groupId) }}</h3>

          <b-table :data="pdfList" striped
            :draggable="role !== 'viewer'"
            @dragstart="dragstart($event, groupId)"
            @drop="drop($event, groupId)"
            @dragover="dragover"
            @dragleave="dragleave">
            <template slot-scope="props">
              <b-table-column centered>
                <b-icon icon="grip-vertical">
                </b-icon>
              </b-table-column>
              <b-table-column field="title" label="Title" centered>
                {{ props.row.title }}
              </b-table-column>

              <b-table-column field="description" label="Description" centered>
                {{ props.row.desc }}
              </b-table-column>

              <b-table-column field="url" label="File" centered>
                <a :href="props.row.url" target="_blank">
                  {{ props.row.fileName }}
                </a>
              </b-table-column>

              <b-table-column field="editDelete" label="Edit/Delete" centered>
                <b-button icon-left="edit" @click="editPdfModal(props.index, groupId)"
                          class="button is-info is-small"></b-button>

                <b-button :disabled="role === 'viewer'" icon-left="trash"
                          @click="deletePdfDialog(props.index, groupId)"
                          class="button is-danger is-small">
                </b-button>
              </b-table-column>
            </template>
          </b-table>

        </div>
      </div>
      <div v-else class="container">
      </div>
      <vue-fab v-if="!bAddPdf" title="Add PDF" :scrollAutoHide="autoHide" mainBtnColor="#48c78e" icon="add" size="big" @clickMainBtn="addPdfModal" :hidden="role === 'viewer'"/>
    </section>
  </template>

<script>
import AppMenuPdfAddEdit from '@/components/appmenu/AppMenuPdfAddEdit'

export default {
  name: 'AppMenuPdfs',
  data: () => {
    return {
      groupedTableData: {},
      autoHide: false,
      deleteFile: 0,
      loadingComponent: null,
      bAddPdf: false,
      draggingRowIndex: null,
      draggingGroupId: null
    }
  },
  computed: {
    addOns () {
      return this.$store.state.addOns
    },
    appMenuPdfs () {
      return this.$store.state.appMenuPdfs
    },
    appMenu () {
      return this.$store.state.appMenu
    },
    role () {
      return this.$store.state.role
    }
  },
  watch: {
    appMenuPdfs () {
      this.groupedTableData = {}
      this.buildTableGroups()
    }
  },
  mounted: function () {
    if (this.appMenuPdfs) {
      this.buildTableGroups()
    }
  },
  methods: {
    getAppMenuPdfItem (pdfItemId) {
      let appMenuPdfItemTitle = ''
      if (this.appMenu) {
        for (let i = 0; i < 6; i++) {
          let appMenuItem = this.appMenu.items[i]
          if (appMenuItem.type === 'pdf') {
            if (appMenuItem.id === pdfItemId) {
              appMenuPdfItemTitle = appMenuItem.appItemTitle
              break
            }
          }
        }
      }
      return appMenuPdfItemTitle
    },
    addPdfModal () {
      if (this.role !== 'viewer') {
        this.bAddPdf = true
        this.$buefy.modal.open({
          parent: this,
          component: AppMenuPdfAddEdit,
          props: { propParentFn: this.cancelAdd },
          hasModalCard: true,
          trapFocus: true,
          onCancel: this.cancelAdd,
          canCancel: ['x']
        })
      }
    },
    editPdfModal (id, groupId) {
      this.bAddPdf = true
      this.$buefy.modal.open({
        parent: this,
        component: AppMenuPdfAddEdit,
        props: { propItem: this.groupedTableData[groupId][id], propParentFn: this.cancelAdd },
        hasModalCard: true,
        trapFocus: true,
        onCancel: this.cancelAdd,
        canCancel: ['x']
      })
    },
    deletePdfDialog (id, groupId) {
      this.$buefy.dialog.confirm({
        message: 'Are you sure that you want to delete PDF "' + this.groupedTableData[groupId][id].title + '"?',
        cancelText: 'No',
        confirmText: 'Yes',
        type: 'is-danger',
        onConfirm: () => {
          this.deletePdf(id, groupId)
        }
      })
    },
    deletePdf (id, groupId) {
      this.loadingComponent = this.$buefy.loading.open()

      let pdfIdE = this.groupedTableData[groupId][id].id
      let resourceName = this.groupedTableData[groupId][id].fileName
      let appMenuPdfId = this.groupedTableData[groupId][id].appMenuPdfId

      this.deleteFile = true

      // check if file is used by another document
      for (let pdfAppMenuId in this.appMenuPdfs) {
        for (let pdfId in this.appMenuPdfs[pdfAppMenuId]) {
          if (pdfId !== pdfIdE) {
            if (this.appMenuPdfs[pdfAppMenuId][pdfId].fileName === resourceName) {
              this.globalLogger('delete file is false')
              this.deleteFile = false
            }
          }
        }
      }

      if (this.deleteFile) {
        this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/AppMenuPdfs/' + resourceName).delete()
          .then(() => {
            this.$store.state.database.ref('/neoslide/appMenuPdfs/' + this.$store.state.workspaceId + '/' + appMenuPdfId + '/' + pdfIdE).remove()
              .then(() => {
                this.loadingComponent.close()
              })
              .catch(error => {
                this.loadingComponent.close()
                this.globalLogger('could not remove pdf', error)
                this.showAlert()
              })
          })
          .catch(error => {
            this.loadingComponent.close()
            this.globalLogger('could not delete previous file', error)
            this.showAlert()
          })
      } else {
        this.$store.state.database.ref('/neoslide/appMenuPdfs/' + this.$store.state.workspaceId + '/' + appMenuPdfId + '/' + pdfIdE).remove()
          .then(() => {
            this.loadingComponent.close()
          })
          .catch(error => {
            this.loadingComponent.close()
            this.globalLogger('could not remove pdf', error)
            this.showAlert()
          })
      }
    },
    showAlert () {
      this.$buefy.dialog.alert({
        title: 'Operation faild',
        message: 'Deleting PDF failed. Please try again.',
        type: 'is-danger',
        hasIcon: true,
        icon: 'times-circle',
        iconPack: 'fa',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    cancelAdd () {
      this.bAddPdf = false
    },
    buildTableGroups () {
      const groups = {}

      for (let appMenuPdfId in this.appMenuPdfs) {
        groups[appMenuPdfId] = []

        for (let pdfId in this.appMenuPdfs[appMenuPdfId]) {
          groups[appMenuPdfId].push({
            id: pdfId,
            appMenuPdfId,
            ...this.appMenuPdfs[appMenuPdfId][pdfId]
          })
        }

        groups[appMenuPdfId].sort((a, b) => {
          const orderA = a.order !== undefined ? a.order : 0
          const orderB = b.order !== undefined ? b.order : 0
          return orderA - orderB
        })
      }

      this.groupedTableData = groups
    },
    saveOrder (groupId) {
      const workspaceId = this.$store.state.workspaceId
      const database = this.$store.state.database

      const promises = this.groupedTableData[groupId].map(doc => {
        return database.ref(`neoslide/appMenuPdfs/${workspaceId}/${groupId}/${doc.id}/order`).set(doc.order)
      })

      Promise.all(promises)
        .then(() => {
          this.globalLogger('orders updated')
        })
        .catch(error => {
          this.handleError(error)
        })
    },
    dragstart (payload, groupId) {
      this.draggingRow = payload.row
      this.draggingRowIndex = payload.index
      this.draggingGroupId = groupId
      payload.event.dataTransfer.effectAllowed = 'copy'
    },
    dragover (payload) {
      payload.event.dataTransfer.dropEffect = 'copy'
      payload.event.target.closest('tr').classList.add('is-selected')
      payload.event.preventDefault()
    },
    dragleave (payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      payload.event.preventDefault()
    },
    drop (payload, groupId) {
      payload.event.target.closest('tr').classList.remove('is-selected')

      if (this.draggingGroupId !== groupId) return

      const from = this.draggingRowIndex
      const to = payload.index

      if (from === to) return

      const movedItem = this.groupedTableData[groupId].splice(from, 1)[0]
      this.groupedTableData[groupId].splice(to, 0, movedItem)

      this.groupedTableData[groupId].forEach((doc, index) => {
        doc.order = index
      })

      this.draggingRowIndex = null
      this.draggingGroupId = null

      this.saveOrder(groupId)
    }
  }
}
</script>
<style scoped>
.topPadding {
  padding-top: 14px
}
</style>



// WEBPACK FOOTER //
// src/components/appmenu/AppMenuPdfs.vue